import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'glamor';
// import * as R from 'ramda';
import { I18n, Translate } from 'react-redux-i18n';
import SelectionGrid from '../../_Common/Grids/SelectionGrid';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { DateCellRenderer, PercentageCellRenderer, MeasureCellRenderer, LimitedMeasureCellRenderer } from '../../_Common/Grids';

const actionButtonsRenderer = props => {
  const { data, onConfirm, onIgnore, node } = props;
  return (
    <div style={{ textAlign: 'center' }}>
      {node.level === 0 && (
        <ButtonToolbar>
          <Button bsSize="xsmall" type="button" onClick={() => onConfirm(data)}>
            <i className="fa fa-print" aria-hidden="true" />
            &nbsp;
            <Translate value="impactAssessmentProduct.confirm" />
          </Button>
          <Button bsSize="xsmall" type="button" onClick={() => onIgnore(data)}>
            <i className="fa fa-print" aria-hidden="true" />
            &nbsp;
            <Translate value="impactAssessmentProduct.ignore" />
          </Button>
        </ButtonToolbar>
      )}{' '}
    </div>
  );
};

actionButtonsRenderer.propTypes = {
  data: PropTypes.object.isRequired, //eslint-disable-line
  onConfirm: PropTypes.func.isRequired,
  onIgnore: PropTypes.func.isRequired,
};

const ImpactAssessmentCandidateProductList = props => {
  const {
    currentImpactAssessmentProducts,
    requestingImpactAssessmentCandidateProductList,
    requestingImpactAssessmentList,
    onConfirmImpactAssessmentProductClick,
    onIgnoreImpactAssessmentProductClick,
    onRefresh,
    onRowDoubleClicked,
    requestingFindCandidate,
  } = props;

  const tst = currentImpactAssessmentProducts.filter(product => { return product.Values.length === 0 });
  const columns = [
    {
      headerName: 'Id',
      field: 'ImpactAssessmentProductId',
      width: 80,
      suppressSizeToFit: true,
      cellRenderer: 'group',
    },
    {
      headerName: 'ProductId',
      width: 80,
      field: 'ProductId',
    },
    {
      headerName: I18n.t('product.code'),
      width: 95,
      field: 'Code',
      suppressSizeToFit: true,
      cellStyle: { color: 'blue', textDecoration: 'underline dotted' },
      sort: 'asc',
    },
    {
      headerName: I18n.t('general.name'),
      width: 120,
      field: 'ProductName',
    },
    {
      headerName: I18n.t('product.producerName'),
      width: 95,
      field: 'Shortname',
      suppressSizeToFit: false,
    },
    // {
    //   headerName: I18n.t('product.isNotified'),
    //   width: 30,
    //   field: 'IsNotified',
    // },
    // {
    //   headerName: I18n.t('product.notificationDate'),
    //   width: 60,
    //   field: 'NotifiedOn',
    // },
    // {
    //   headerName: I18n.t('product.notificationCode'),
    //   width: 30,
    //   field: 'NotificationCode',
    // },
    // {
    //   headerName: I18n.t('product.category'),
    //   width: 30,
    //   field: 'CategoryDescription',
    // },
    {
      headerName: I18n.t('impactAssessmentProduct.notificationDateEU'),
      width: 50,
      field: 'NotifiedEU',
      cellRenderer: DateCellRenderer,
      cellRendererParams: {
        includeHours: false,
      },
    },
    {
      headerName: I18n.t('impactAssessmentProduct.notificationCodeEU'),
      width: 30,
      field: 'NotificationCodeEU',
      suppressSizeToFit: false,
    },
    {
      headerName: I18n.t('impactAssessmentProduct.notificationDateUK'),
      width: 50,
      field: 'NotifiedUK',
      cellRenderer: DateCellRenderer,
      cellRendererParams: {
        includeHours: false,
      },
    },
    {
      headerName: I18n.t('impactAssessmentProduct.notificationCodeUK'),
      width: 30,
      field: 'NotificationCodeUK',
      suppressSizeToFit: false,
    },
    // {
    //   headerName: I18n.t('product.useType'),
    //   width: 75,
    //   field: 'ProductUseTypeCode',
    // },
    {
      headerName: 'Use Type',
      field: 'ProductUseTypeCode',
      width: 75,
      suppressSizeToFit: false,
    },
    {
      headerName: 'Category',
      field: 'CategoryDescription',
      width: 75,
      suppressSizeToFit: false,
    },
    // {
    //   headerName: 'Subs.Type',
    //   field: 'InciType',
    //   width: 75,
    //   suppressSizeToFit: true,
    // },
    // {
    //   headerName: 'Inci',
    //   field: 'InciName',
    //   width: 75,
    //   suppressSizeToFit: true,
    // },
    // {
    //   headerName: 'Test',
    //   field: 'Comparator',
    //   width: 75,
    //   suppressSizeToFit: true,
    // },
    // {
    //   headerName: 'Quantity',
    //   field: 'QuantityValue',
    //   width: 75,
    //   suppressSizeToFit: true,
    //   cellRenderer: PercentageCellRenderer,
    // },
    // {
    //   headerName: 'MoS',
    //   field: 'MoSValue',
    //   width: 75,
    //   suppressSizeToFit: true,
    //   cellRenderer: LimitedMeasureCellRenderer,
    //   cellRendererParams: {
    //     nbDecimal: 0,
    //     max: 1000000
    //   },
    // },
    // {
    //   headerName: 'Out',
    //   cellRenderer: ({ data, node }) => {
    //     if (data.BeyondThreshold) {
    //       return '<i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:#FF0000;"></i>';
    //     }
    //     if (node.level > 0) {
    //       return '<i class="fa fa-check-circle" aria-hidden="true" style="color:#23db23;"></i>';
    //     }
    //     return '';
    //   },
    //   width: 75,
    //   suppressSizeToFit: true,
    // },
    // {
    //   headerName: I18n.t('impactAssessmentProduct.status'),
    //   width: 65,
    //   field: 'Status',
    //   suppressSizeToFit: true,
    // },
    // {
    //   headerName: I18n.t('impactAssessmentProduct.actions'),
    //   cellRendererFramework: actionButtonsRenderer,
    //   cellRendererParams: {
    //     onConfirm: onConfirmImpactAssessmentProductClick,
    //     onIgnore: onIgnoreImpactAssessmentProductClick,
    //   },
    //   width: 200,
    //   minWidth: 200,
    //   suppressSizeToFit: true,
    // },
  ];

  const getNodeChildDetails = rowItem => {
    if (rowItem.Values) {
      return {
        group: true,
        expanded: true,
        children: rowItem.Values,
        key: rowItem.ImpactAssessmentValueId,
      };
    }
    return null;
  };

  return (
      <SelectionGrid
      data={currentImpactAssessmentProducts.filter(product => { return product.Values.length === 0 })}
      // getNodeChildDetails={getNodeChildDetails}
      keyName="id"
      columns={columns}
      isLoading={
        requestingImpactAssessmentCandidateProductList || requestingImpactAssessmentList || requestingFindCandidate
      }
      onRefresh={onRefresh}
      deltaRowDataMode={false}
      rowDoubleClicked={onRowDoubleClicked}
      showAddButton={false}
      showExpandCollapseButtons
    />
  );
};

ImpactAssessmentCandidateProductList.propTypes = {
  currentImpactAssessmentProducts: PropTypes.arrayOf(
    PropTypes.shape({
      impactAssessmentProductId: PropTypes.number,
      status: PropTypes.string,
    }),
  ).isRequired,
  requestingImpactAssessmentCandidateProductList: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onRowDoubleClicked: PropTypes.func.isRequired,
  workflowStatusNameById: PropTypes.object.isRequired, //eslint-disable-line
  onConfirmImpactAssessmentProductClick: PropTypes.func.isRequired,
  onIgnoreImpactAssessmentProductClick: PropTypes.func.isRequired,
};

export default ImpactAssessmentCandidateProductList;
